import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function callerIdNamePhoneValidator(): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    // eslint-disable-next-line no-null/no-null
    const noErrors = null;
    const phoneControl = form.get("phone");
    const nameControl = form.get("name");

    if (!phoneControl || !nameControl) {
      return noErrors;
    }

    if (!phoneControl.value && !nameControl.value) {
      nameControl.setErrors(noErrors);
      phoneControl.setErrors(noErrors);
      return noErrors;
    }

    if (phoneControl.value && !nameControl.value) {
      nameControl.setErrors({ required: true });
      return { name: "required" };
    }

    if (!phoneControl.value && nameControl.value) {
      phoneControl.setErrors({ required: true });
      return { phone: "required" };
    }

    return noErrors;
  };
}
